import React from 'react';
import { Box, Typography, Grid, Card, CardContent, CardActionArea } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SliderCarousel from './SliderCarousel';
import PinnedForums from './PinnedForums';

const Home = ({ user }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const isAdmin = user && user.role && user.role.name.toLowerCase() === 'admin';
    const hasManageSettings = user?.role?.Permissions?.some(p => p.name === 'manage_settings');

    const baseTiles = [
        { title: t('dashboard.tiles.forums'), path: '/dashboard/forums' },
        { title: t('dashboard.tiles.resources'), path: '/dashboard/resources' },
        { title: t('dashboard.tiles.reminders'), path: '/dashboard/reminders' },
    ];

    const adminTiles = [
        { title: 'Slideshow', path: '/dashboard/sliders' },
    ];

    // Submissions: admins or roles granted the manage_submissions permission.
    const hasManageSubmissions = user?.role?.Permissions?.some(p => p.name === 'manage_submissions');
    if (isAdmin || hasManageSubmissions) {
        adminTiles.push({ title: t('dashboard.tiles.submissions'), path: '/dashboard/submissions' });
    }

    const tiles = [
        ...baseTiles,
        ...(isAdmin || hasManageSettings ? adminTiles : [])
    ];

    return (
        <Box>
            <SliderCarousel />

            <Typography variant="h4" gutterBottom sx={{ fontSize: { xs: '1.75rem', md: '2.125rem' }, mt: { xs: 2, md: 0 } }}>
                {t('dashboard.welcome')}, {user.firstName} {user.lastName}!
            </Typography>
            <Typography variant="body1" gutterBottom sx={{ fontSize: { xs: '0.95rem', md: '1rem' } }}>
                {t('dashboard.description')}
            </Typography>
            <Grid container spacing={{ xs: 2, md: 3 }} sx={{ mt: 2 }}>
                {tiles.map((tile) => (
                    <Grid item xs={12} sm={6} md={4} key={tile.title}>
                        <Card>
                            <CardActionArea onClick={() => navigate(tile.path)} sx={{ minHeight: { xs: 80, md: 100 } }}>
                                <CardContent>
                                    <Typography variant="h6" component="div" sx={{ fontSize: { xs: '1.1rem', md: '1.25rem' } }}>
                                        {tile.title}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            <PinnedForums />
        </Box>
    );
};

export default Home;